import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { iconSeverityPicker } from '../../../helpers/IconHelper';
import { useMessageStyles } from './styles';

const Message = ({ ...props }) => {
  const { severity, message, fullRounded, mobile, testId } = props;
  const classes = useMessageStyles({ fullRounded, mobile });
  return (
    <Box
      className={`${classes.container} ${classes[severity]}`}
      data-testid={testId}
    >
      <Box display="flex">
        <img
          className={classes.image}
          src={iconSeverityPicker(severity)}
          alt=""
        />
        <Typography className={classes.text}>{message} </Typography>
      </Box>
    </Box>
  );
};

Message.defaultProps = {
  mobile: false,
};

Message.propTypes = {
  severity: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  fullRounded: PropTypes.bool,
  mobile: PropTypes.bool,
  testId: PropTypes.string,
};

export default Message;
